// extracted by css-extract-rspack-plugin
export default {"bind-modal":"bind-modal-uvzGtQ","bindModal":"bind-modal-uvzGtQ"};